"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNil = void 0;
// taken from lodash https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_isnil
// eslint-disable-next-line eqeqeq, @typescript-eslint/no-explicit-any
const isNil = (val) => val == null;
exports.isNil = isNil;
//# sourceMappingURL=isNil.js.map